import { FacetOption } from "modules/FacetsModule/components/FacetOption";
import { NodeTree } from "modules/FacetsModule/FacetsModule.types";

export const prepareCountAndTitle = (treeNode: NodeTree) => {
  (treeNode.children || []).map((el) => prepareCountAndTitle(el));
  const childCount = (treeNode.children || []).reduce((sum, el) => sum + (el.count || 0), 0);

  treeNode.title = <FacetOption title={treeNode.title || treeNode.key || ""} count={childCount + (treeNode.count || 0)} />;
};
